import { cn } from '@/lib/utils';

/**
 * Amber pill shown next to a product when the user has picked one that
 * isn't covered by any SOW for the row's customer in the displayed week.
 *
 * The amber tone mirrors the rejected-status / partial-day badges
 * elsewhere on the timesheet — same visual language for "this needs your
 * attention, but it's a choice, not a hard error."
 */
export function OutOfScopeBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'rounded bg-amber-100 px-1 text-[10px] font-medium uppercase tracking-wide text-amber-900 dark:bg-amber-900/30 dark:text-amber-200',
        className,
      )}
      title="No engagement covers this activity for this customer in the displayed week."
    >
      Out of scope
    </span>
  );
}
